// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listaHorizontal{
    float: left;
    list-style:none;
}

.toolbar-toolkit ul li:first-child button {
    margin: 0;
    display: block;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    border-top: 1px solid #004f87;
    border-right: 1px solid #004f87;
    border-left: 1px solid #004f87;
    border-bottom: 1px solid #004f87;

}

.toolbar-toolkit ul li button {
    margin: 0;
    display: block;
    border-top: 1px solid #004f87;
    border-right: 1px solid #004f87;
    border-left: none;
    border-bottom: 1px solid #004f87;
}

.toolbar-toolkit ul li:nth-child(4) button {
    margin: 0;
    display: block;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    border-top: 1px solid #004f87;
    border-right: 1px solid #004f87;
    border-left: none;
    border-bottom: 1px solid #004f87;

}

.toolbar-toolkit button {
    /*display: block;*/
    background: #fff;
    text-align: center;
    padding: 5px 9px;
    font-size: 14px;
    border: medium none;
    color: #004f87;
}

.isSelected{
    background: #004f87 !important;
    color: #fff !important;
}

.toolbar-toolkit button:hover {
    background: #e2e2e2 none repeat scroll 0 0;
    margin: 0;
}

.divAlerta {
    position: fixed;
    bottom: 90px;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/footer-visualizer/footer-visualizer.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,2BAA2B;IAC3B,8BAA8B;IAC9B,6BAA6B;IAC7B,+BAA+B;IAC/B,8BAA8B;IAC9B,gCAAgC;;AAEpC;;AAEA;IACI,SAAS;IACT,cAAc;IACd,6BAA6B;IAC7B,+BAA+B;IAC/B,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,cAAc;IACd,4BAA4B;IAC5B,+BAA+B;IAC/B,6BAA6B;IAC7B,+BAA+B;IAC/B,iBAAiB;IACjB,gCAAgC;;AAEpC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,0CAA0C;IAC1C,SAAS;AACb;;AAEA;IACI,eAAe;IACf,YAAY;AAChB","sourcesContent":[".listaHorizontal{\r\n    float: left;\r\n    list-style:none;\r\n}\r\n\r\n.toolbar-toolkit ul li:first-child button {\r\n    margin: 0;\r\n    display: block;\r\n    border-top-left-radius: 6px;\r\n    border-bottom-left-radius: 6px;\r\n    border-top: 1px solid #004f87;\r\n    border-right: 1px solid #004f87;\r\n    border-left: 1px solid #004f87;\r\n    border-bottom: 1px solid #004f87;\r\n\r\n}\r\n\r\n.toolbar-toolkit ul li button {\r\n    margin: 0;\r\n    display: block;\r\n    border-top: 1px solid #004f87;\r\n    border-right: 1px solid #004f87;\r\n    border-left: none;\r\n    border-bottom: 1px solid #004f87;\r\n}\r\n\r\n.toolbar-toolkit ul li:nth-child(4) button {\r\n    margin: 0;\r\n    display: block;\r\n    border-top-right-radius: 6px;\r\n    border-bottom-right-radius: 6px;\r\n    border-top: 1px solid #004f87;\r\n    border-right: 1px solid #004f87;\r\n    border-left: none;\r\n    border-bottom: 1px solid #004f87;\r\n\r\n}\r\n\r\n.toolbar-toolkit button {\r\n    /*display: block;*/\r\n    background: #fff;\r\n    text-align: center;\r\n    padding: 5px 9px;\r\n    font-size: 14px;\r\n    border: medium none;\r\n    color: #004f87;\r\n}\r\n\r\n.isSelected{\r\n    background: #004f87 !important;\r\n    color: #fff !important;\r\n}\r\n\r\n.toolbar-toolkit button:hover {\r\n    background: #e2e2e2 none repeat scroll 0 0;\r\n    margin: 0;\r\n}\r\n\r\n.divAlerta {\r\n    position: fixed;\r\n    bottom: 90px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
